import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useToast } from '../hooks/use-toast';
import { LogIn } from 'lucide-react';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      console.log('Attempting login with:', username);
      
      const response = await fetch('/api/admin/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      console.log('Response status:', response.status);

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('Login error:', errorData);
        throw new Error('Invalid credentials');
      }

      const data = await response.json();
      console.log('Login successful, storing token');
      localStorage.setItem('adminToken', data.access_token);
      
      toast({
        title: "Login successful!",
        description: "Welcome to the admin panel.",
      });
      
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error caught:', error);
      setIsLoading(false);
      toast({
        title: "Login failed",
        description: "Invalid username or password.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#f7f5f2' }}>
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="text-center mb-8">
            <img 
              src="https://customer-assets.emergentagent.com/job_48fa2328-69a6-47d6-a09d-67288600a773/artifacts/di13voej_A14597EA-17F5-436E-B720-266D21072789.PNG" 
              alt="The Maple Daddies" 
              className="h-20 w-auto mx-auto mb-4"
            />
            <h1 className="text-3xl font-bold" style={{ color: '#4a2c1a' }}>
              Admin Login
            </h1>
            <p className="text-sm mt-2" style={{ color: '#736c64' }}>
              Enter your credentials to access the admin panel
            </p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <Label htmlFor="username" className="text-base font-semibold" style={{ color: '#4a2c1a' }}>
                Username
              </Label>
              <Input
                id="username"
                type="text"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="mt-2 border-2"
                style={{ borderColor: '#e5d5c0' }}
                placeholder="Enter username"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-base font-semibold" style={{ color: '#4a2c1a' }}>
                Password
              </Label>
              <Input
                id="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 border-2"
                style={{ borderColor: '#e5d5c0' }}
                placeholder="Enter password"
              />
            </div>

            <Button
              type="submit"
              disabled={isLoading}
              className="w-full text-white font-semibold py-6 text-lg hover:opacity-90 transition-opacity"
              style={{ backgroundColor: '#FF8C19' }}
            >
              <LogIn className="h-5 w-5 mr-2" />
              {isLoading ? 'Logging in...' : 'Login'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <a href="/" className="text-sm hover:underline" style={{ color: '#FF8C19' }}>
              ← Back to website
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
